import featureFlagMixin from '@motionelements/core/src/components/mixins/feature-flag.mixin.js';
import routeConst from './const.js';

export default [
  {
    path: '',
    name: routeConst.ARTIST_DASHBOARD,
    component: () => {
      if (featureFlagMixin.methods.isFeatureEnabled('contributor_redesign_2023')) {
        return import(
          /* webpackChunkName: "artist-dashboard" */
          '@/views/redesign-2023/dashboard/Dashboard.vue'
        );
      }
      return import(
        /* webpackChunkName: "artist-dashboard" */
        '@/views/artist/dashboard/Dashboard.vue'
      );
    },
  },
  {
    path: 'price-templates',
    name: routeConst.ARTIST_PRICE_TEMPLATE_LIST,
    component: () => import(
      /* webpackChunkName: "artist-price-templates-list-page" */
      '@/views/artist/price-templates/PriceTemplateList.vue'
    ),
  },
  {
    path: 'price-templates/new',
    name: routeConst.ARTIST_PRICE_TEMPLATE_NEW,
    component: () => import(
      /* webpackChunkName: "artist-price-templates-edit-page" */
      '@/views/artist/price-templates/PriceTemplateEdit.vue'
    ),
  },
  {
    path: 'price-templates/edit/:templateId',
    name: routeConst.ARTIST_PRICE_TEMPLATE_EDIT,
    component: () => import(
      /* webpackChunkName: "artist-price-templates-edit-page" */
      '@/views/artist/price-templates/PriceTemplateEdit.vue'
    ),
  },
  // metadata templates
  {
    name: 'artist-metadata-templates',
    path: 'metadata-templates',
    component: () => import(
      /* webpackChunkName: "artist-metadata-templates" */
      '@/views/artist/metadata-templates/MetadataTemplates.vue'
    ),
    children: [
      {
        name: 'artist-metadata-templates-list',
        path: '',
        component: () => import(
          /* webpackChunkName: "artist-metadata-templates-list" */
          '@/views/artist/metadata-templates/MetadataTemplatesList.vue'
        ),
      },
      {
        name: 'artist-metadata-templates-new',
        path: 'new',
        component: () => import(
          /* webpackChunkName: "artist-metadata-templates-new" */
          '@/views/artist/metadata-templates/MetadataTemplatesNew.vue'
        ),
      },
      {
        name: 'artist-metadata-templates-edit',
        path: ':id',
        component: () => import(
          /* webpackChunkName: "artist-metadata-templates-edit" */
          '@/views/artist/metadata-templates/MetadataTemplateEdit.vue'
        ),
      },
    ],
  },
  {
    path: 'upload',
    name: routeConst.ARTIST_UPLOAD,
    component: () => {
      if (featureFlagMixin.methods.isFeatureEnabled('contributor_redesign_2023')) {
        return import(
          /* webpackChunkName: "artist-upload-page" */
          '@/views/redesign-2023/upload/UploadPage.vue'
        );
      }
      return import(
        /* webpackChunkName: "artist-upload-page" */
        '@/views/artist/upload/IndexPage.vue'
      );
    },
  },
  {
    path: 'sales',
    name: routeConst.ARTIST_SALES,
    component: () => import(
      /* webpackChunkName: "artist-sales-page" */
      '@/views/artist/Sales.vue'
    ),
  },
  {
    path: 'payout',
    name: routeConst.ARTIST_PAYOUT,
    component: () => import(
      /* webpackChunkName: "artist-payouts-list-page" */
      '@/views/artist/payouts/ListPage.vue'
    ),
  },
  {
    path: 'profile',
    name: 'artist-profile',
    component: () => import(
      /* webpackChunkName: "artist-profile" */
      '@/views/redesign-2023/profile/ProfilePage.vue'
    ),
  },
  {
    path: 'settings',
    redirect: 'settings/profile',
    name: routeConst.ARTIST_SETTINGS,
    component: () => import(
      /* webpackChunkName: "artist-payouts-list-page" */
      '@/views/artist/settings/ArtistSettings.vue'
    ),
    children: [
      {
        path: 'profile',
        name: 'artist-settings-profile',
        component: () => import(
          /* webpackChunkName: "artist-settings-profile" */
          '@/views/artist/settings/Profile.vue'
        ),
      },
      {
        path: 'advanced',
        name: 'artist-settings-advanced',
        component: () => import(
          /* webpackChunkName: "artist-settings-advanced" */
          '@/views/artist/settings/advanced/AdvancedSettings.vue'
        ),
      },
    ],
  },
  {
    path: 'creators',
    name: routeConst.ARTIST_CREATOR_LIST,
    component: () => import(
      /* webpackChunkName: "artist-creators-list-page" */
      '@/views/artist/creator/ListPage.vue'
    ),
  },
  {
    path: 'sales/list',
    name: routeConst.ARTIST_SALES_ON_DEMAND,
    component: () => import(
      /* webpackChunkName: "artist-sales-list-od" */
      '@/views/artist/sales/list/OnDemand.vue'
    ),
  },
  {
    path: 'youtube-content-id',
    name: 'youtube-content-id',
    component: () => import(/* webpackChunkName: "artist-content-id" */ '@/views/artist/content-id/YoutubeContentIdSettings.vue'),
  },
  {
    path: 'release/list',
    redirect: '/artist/releases',
  },
  {
    path: 'releases',
    name: routeConst.ARTIST_RELEASE_LIST,
    component: () => import(
      /* webpackChunkName: "artist-releases-list-page" */
      '@/views/artist/release/ListPage.vue'
    ),
  },
  {
    path: 'element/list',
    redirect: '/artist/elements',
  },
  {
    path: 'element/manage',
    redirect: '/artist/elements',
  },
  {
    path: 'elements',
    name: routeConst.ARTIST_ELEMENT_LIST,
    component: () => import(
      /* webpackChunkName: "artist-elements-list-page" */
      '@/views/artist/element/ListPage.vue'
    ),
  },
  {
    path: 'elements/failed-uploads',
    name: 'artist-element-list-failed-uploads',
    component: () => import(
      /* webpackChunkName: "artist-elements-failed-uploads-list-page" */
      '@/views/artist/element/ListPage.vue'
    ),
  },
  {
    path: 'collection/list',
    redirect: '/artist/collections',
  },
  {
    path: 'collection/manage',
    redirect: '/artist/collections',
  },
  {
    path: 'collections',
    name: routeConst.ARTIST_COLLECTION_LIST,
    component: () => import(
      /* webpackChunkName: "artist-collections-list-page" */
      '@/views/artist/collection/ListPage.vue'
    ),
  },
  // {
  //   path: 'collections/new',
  //   // alias: '/:lang?/artist/collection/editor/:collectionId', // temp for transition
  //   name: routeConst.ARTIST_COLLECTION_NEW,
  //   component: () => import(/* webpackChunkName: "artist-collections-edit" */ '@/views/artist/collection/edit/Edit.vue'),
  //   meta: {
  //     new: true,
  //   },
  // },
  {
    path: 'programs',
    component: () => import(/* webpackChunkName: "artist-programs" */ '@/views/artist/Programs.vue'),
    children: [
      {
        path: '',
        name: 'artist-programs',
        component: () => import(
          /* webpackChunkName: "artist-programs-list-page" */
          '@/views/artist/programs/ListPage.vue'
        ),
      },
      {
        path: 'convert-hd',
        name: 'convert-hd',
        component: () => import(
          /* webpackChunkName: "artist-addons-convert-hd-page" */
          '@/views/artist/programs/ConvertHd.vue'
        ),
      },
      {
        path: 'convert-video-image',
        name: 'convert-video-image',
        component: () => import(
          /* webpackChunkName: "artist-addons-convert-video-image-page" */
          '@/views/artist/programs/ConvertVideoToImageGif.vue'
        ),
      },
      {
        path: 'ftp',
        name: 'ftp',
        component: () => import(
          /* webpackChunkName: "artist-addons-ftp-page" */
          '@/views/artist/programs/ftp/UploadByFtp.vue'
        ),
      },
      {
        path: 'ftp/change-password',
        name: 'change-ftp-password',
        component: () => import(
          /* webpackChunkName: "artist-addons-ftp-change-password" */
          '@/views/artist/programs/ftp/ChangeFtpPassword.vue'
        ),
      },
      {
        path: 'gcp/:programId',
        name: 'gcp',
        component: () => import(
          /* webpackChunkName: "artist-programs-gcp" */
          '@/views/artist/programs/gcp/GcpAgreement.vue'
        ),
      },
    ],
  },
];
